











import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "legacy-invoices-provider": () =>
      import(
        "@/components/app/global/legacyInvoices/legacyInvoicesProvider.vue"
      ),
    "legacy-invoices-table": () =>
      import("@/components/app/global/legacyInvoices/legacyInvoicesTable.vue")
  }
})
export default class AdminLegacyInvoicesView extends Vue {
  // Life-cycle methods

  public mounted() {
    this.$bus.$emit("scrollToTop");
  }
}
